import { PATH } from './route.constants';
import type { Route } from './route.types';

export const ROUTE: Route = {
  faqs: {
    create: `${PATH.create}/:type/:id`,
    edit: `${PATH.edit}/:type/:id`,
    main: '/faqs',
  },
  media: {
    upload: PATH.upload,
    main: '/media',
  },
  modules: {
    create: PATH.create,
    edit: `${PATH.edit}/:id`,
    main: '/modules',
    upload: PATH.upload,
  },
  modulesContent: {
    create: PATH.create,
    edit: `${PATH.edit}/:id`,
    main: '/:moduleId',
    upload: PATH.upload,
  },
  notFound: '*',
  notificationCenterTemplates: {
    upload: PATH.upload,
    main: '/notification_center_templates',
  },
  onboardingsplash: {
    create: PATH.create,
    edit: `${PATH.edit}/:id`,
    main: '/onboardingsplash',
  },
  root: '/',
  rules: {
    create: PATH.create,
    edit: `${PATH.edit}/:id`,
    main: '/rules',
  },
  targetGroups: {
    create: PATH.create,
    main: '/target_groups',
  },
} as const;
